export default "__VITE_ASSET__kFGZLGQ4__"